import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export const Customers = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${space.xl};

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: ${breakpoint.xl}) {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const Link = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 95, 127, 0);
  transition: background-color 0.3s ease;
`

export const WrapIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space.xl4};
  height: ${space.xl4};
  border-radius: ${borders.radius.circle};
  border-radius: ${borders.sizes.sm} solid ${color.grayscale.white};
  color: ${color.grayscale.white};
  opacity: 0;
  transition: opacity 0.3s ease;
`

export const Customer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0;
  height: 8.5rem;
  padding: ${space.lg};
  border: ${borders.sizes.md} solid ${color.grayscale.gray};
  border-radius: ${borders.radius.lg};
  background-color: ${color.grayscale.white};
  overflow: hidden;
  transition: border 0.3s ease;

  &:hover,
  &:focus {
    border-color: ${color.primary.dark};

    ${Link} {
      background-color: rgb(0, 95, 127, 0.9);
    }

    ${WrapIcon} {
      opacity: 1;
    }
  }

  @media (min-width: ${breakpoint.md}) {
    height: 11.5rem;
    padding: ${space.xl2};
  }

  img {
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }
`
